import { useFormik } from 'formik';
import moment from 'moment';
import { useState } from 'react';
import DataTable, { TableColumn } from 'react-data-table-component';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import {
  Button,
  Card,
  CardBody,
  Container,
  Form,
  FormGroup,
  Label
} from 'reactstrap';
import { InputField } from 'src/components';
import BetterBreadcrumb from 'src/components/Common/BetterBreadCrumb';
import { actionColumnStyles, dataTableCustomStyles } from 'src/components/Common/FixedActionColumn';
import DeleteInformationModal from 'src/components/DeleteInformation/DeleteInformationModal';
import { useAppSelector } from 'src/rtk/app/hook';
import { useDeleteScheduleMutation, useGetScheduleListForExaminerQuery } from 'src/rtk/features/logbookMonitoringReport/logbookMonitoringReportApi';
import { useGetOrganizationsQuery } from 'src/rtk/features/setup/organization/setupOrganizationApi';
import { useGetSubjectInfosQuery } from 'src/rtk/features/setup/subjectInfo/subjectInfoApi';
import loader from '../../assets/images/loader.gif';
import ScheduleCreateModal from './ScheduleCreateModal';
import ScheduleEditModal from './ScheduleEditModal';


const InterviewScheduleCreate = () => {
  const authUser = useAppSelector((state) => state.auth.user);

  const [showAddForm, setShowAddForm] = useState<boolean>(false);
  const [showEditForm, setShowEditForm] = useState<boolean>(false);
  const [rowData, setRowData] = useState<any>(null);
  const [page, setPage] = useState<any>(1);
  const [limit, setLimit] = useState<any>(10);
  const [search, setSearch] = useState('');
  
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [selectedSubject, setSelectedSubject] = useState<any>('');
  const [selectedInstitue, setSelectedInstitute] = useState<any>('');

  const currentYear = new Date().getFullYear();
  const startYear = 2025;

  const years = [];
  for (let year = currentYear; year >= startYear; year--) {
    years.push(year);
  }

  const allYears: SelectOption[] = years?.map((item: any) => ({
    value: item,
    label: item,
  })) || [];

  const instituteList: SelectOption[] =
    useGetOrganizationsQuery()
      .data?.data?.map((item) => ({
        value: item.id!,
        label: item.organization_name!,
      }))
      .sort((a, b) => {
        return a.label.localeCompare(b.label);
      }) || [];

  const { data: subjects } = useGetSubjectInfosQuery();

  const allSubjects: SelectOption[] =
    subjects?.data?.map((subject) => ({
      value: subject.subject_name,
      label: subject.subject_name,
    })) || [];

  const courseSession: SelectOption[] = [
    { value: 'January-June', label: 'January-June' },
    { value: 'July-December', label: 'July-December' },
  ];
  const generateQueryUrl = () => {
    return `page=${page}&paginate_per_page=${limit}${search}`;
  };

  const handlePageChange = (page: number) => {
    setPage(page);
  };

  const handlePerRowsChange = (newPerPage: number, page: number) => {
    setLimit(newPerPage);
    setPage(page);
  };

  const { data: scheduleListData, isLoading } = useGetScheduleListForExaminerQuery(generateQueryUrl());

  const [deleteSchedule, { isLoading: isDeleting, isSuccess: isDeleteSuccess, isError: isDeleteError }] = useDeleteScheduleMutation();
  console.log(scheduleListData)
  const columns: TableColumn<any>[] = [
    {
      name: <div>Sl. No.</div>,
      width: '80px',
      cell: (row, index) => <strong>{index + 1}</strong>,
    },

    {
      name: <div>Venue Name</div>,
      selector: (row) => row?.interview_venue,
      wrap: true,
    },

    {
      name: <div>Interview Date</div>,
      selector: (row) => moment(row?.interview_date).format('DD-MMM-YYYY'),
      wrap: true,
    },
    {
      name: <div>Interview Time</div>,
      selector: (row) => moment(row?.interview_time, 'HH:mm:ss').format('hh:mm A'),
      wrap: true,
    },

    {
      name: <div>Session & Year</div>,
      selector: (row) => `${row?.session_name} - ${row?.session_year}`,
      wrap: true,
    },
    ...(authUser?.type === 'Operation' ? [
      {
        name: <div>Institute Name</div>,
        selector: (row: any) =>
          row?.internal_examiner_info?.details?.current_employment_info?.institute_name,
        wrap: true,
      }] : []),
    ...(authUser?.type === 'Operation' ? [
      {
        name: <div>Internal Examiner</div>,
        selector: (row: any) =>
          row?.internal_examiner_info?.details?.personal_info?.full_name,
        wrap: true,
      }] : []),

    {
      name: <div>External Examiner</div>,
      selector: (row) => row?.external_examiner_info?.details?.personal_info?.full_name,
      wrap: true,
    },

    {
      name: <div>Action</div>,
      style: actionColumnStyles,
      width: authUser?.type.toLowerCase() !== 'operation' ? '300px' : '150px',
      cell: (row, index) => (
        <div className='d-flex gap-1 my-1'>
          {authUser?.type.toLowerCase() !== 'operation' &&
            <Button
              color="primary"
              size="sm"
              onClick={() => {
                setShowEditForm(true);
                setRowData(row);
              }}
              disabled={authUser?.id !== row?.internal_examiner_id}
            >
              Edit
            </Button>}

          <Link
            to={{ pathname: `/trainee-schedule-list/${row?.id}` }}
            className="btn btn-success btn-sm waves-effect waves-light me-1"
          >
            Trainee List
          </Link>
          {authUser?.type.toLowerCase() !== 'operation' &&
            <Button
              color="danger"
              size="sm"
              onClick={() => {
                setRowData(row);
                setDeleteModalShow(true);
              }}
            >
              Delete
            </Button>}

          {
            (rowData?.id === row.id && showEditForm) && (
              <ScheduleEditModal
                isOpen={showEditForm}
                toggle={() => {
                  setShowEditForm(!showEditForm);
                }}
                editData={rowData}
              />
            )
          }

          {deleteModalShow && rowData?.id === row.id ? (
            <DeleteInformationModal
              isOpen={deleteModalShow}
              toggle={() => setDeleteModalShow(!deleteModalShow)}
              id={row.id}
              deleteInfomation={deleteSchedule}
            />
          ) : null}
        </div>
      ),
    },
  ];

  interface SearchFields {
    search?: string;
    subject?: string;
    institute_id?: string;
    from_date?: string;
    to_date?: string;
  }

  const searchInitialValues: SearchFields = {
    search: '',
    subject: '',
    institute_id: '',
    from_date: '',
    to_date: '',
  };

  const {
    handleSubmit: searchSubmit,
    getFieldProps: searchGetFieldProps,
    values: searchValues,
    touched,
    errors,
    setFieldValue,
    resetForm: searchResetForm,
  } = useFormik({
    initialValues: searchInitialValues,

    onSubmit: (searchValues) => {
      let s: string = '';

      if (searchValues.search && searchValues.search !== '') {
        s = s + `&search=${searchValues.search}`;
      }

      if (searchValues.subject && searchValues.subject !== '') {
        s = s + `&subject=${searchValues.subject}`;
      }

      if (searchValues.institute_id && searchValues.institute_id !== '') {
        s = s + `&institute_id=${searchValues.institute_id}`;
      }


      if (searchValues.from_date && searchValues.from_date !== '') {
        s = s + `&from_date=${searchValues.from_date}`;
      }

      if (searchValues.to_date && searchValues.to_date !== '') {
        s = s + `&to_date=${searchValues.to_date}`;
      }

      setSearch(s);
      setPage('1');
      // setLimit(20);
    },
  });
  return (
    <div className="page-content">
      {isLoading ? (
        <div className="overlay">
          <img src={loader} alt="Loading" height={100} width={300} />
        </div>
      ) : null}
      <Container fluid>
        <div className='page-breadcrumb-wrapper'>
          <BetterBreadcrumb
            breadcrumbItem={[{ link: '#', name: 'Logbook Monitoring' }]}
            title={'Interview Schedule List'}
          />
          {authUser?.type.toLowerCase() !== 'operation' &&
            <div>
              <Button color="primary" onClick={() => setShowAddForm(true)}>
                Create Interview Schedule
              </Button>
            </div>}
        </div>
        <Card>
          <CardBody>
            <div className="gap-2 ">
              <Form
                className="custom-form"
                onSubmit={(e) => {
                  e.preventDefault();
                  searchSubmit();
                }}
              >
                <div className="filter-wrapper">
                  <FormGroup>
                    <Label for="institute_id">Institute</Label>
                    <Select
                      isClearable={true}
                      isSearchable={true}
                      value={selectedInstitue}
                      onChange={setSelectedInstitute}
                      options={instituteList}
                      placeholder='Institute'
                      name="institute_id"
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label for="subject">Subject</Label>
                    <Select
                      isClearable={true}
                      isSearchable={true}
                      value={selectedSubject}
                      onChange={setSelectedSubject}
                      options={allSubjects}
                      placeholder='Select...'
                      name="subject"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="evaluated_from_date">From Date</Label>
                    <InputField
                      type="date"
                      placeholder="From Date"
                      {...searchGetFieldProps('from_date')}
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label for="evaluated_to_date">To Date</Label>
                    <InputField
                      type="date"
                      placeholder="To Date"
                      {...searchGetFieldProps('to_date')}
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label for="session_name">Session Name</Label>
                    <InputField
                      type="select"
                      placeholder="Session Name"
                      options={courseSession}
                      {...searchGetFieldProps('session_name')}
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label for="session_year">Session Year</Label>
                    <InputField
                      type="select"
                      placeholder="Session Year"
                      options={allYears}
                      {...searchGetFieldProps('session_year')}
                    />
                  </FormGroup>

                  <FormGroup className="btn-column mb-3">
                    <Button type="submit" color='primary' outline>Search</Button>
                    <Button color="danger" type="reset" outline>Reset</Button>
                  </FormGroup>

                </div>
              </Form>
            </div>
            <DataTable
              columns={columns}
              data={scheduleListData?.data?.data || []}
              customStyles={dataTableCustomStyles}
              pagination
              paginationServer
              progressPending={isLoading}
              expandOnRowClicked
              highlightOnHover
              onChangePage={handlePageChange}
              onChangeRowsPerPage={handlePerRowsChange}
              paginationTotalRows={scheduleListData?.data?.total}
              paginationRowsPerPageOptions={[2, 5, 10, 20, 50, 100, 200]}
              responsive
              persistTableHead={true}
            />
          </CardBody>
        </Card>

        {showAddForm &&
          <ScheduleCreateModal
            isOpen={showAddForm}
            toggle={() => setShowAddForm(!showAddForm)}
          />

        }
      </Container>
    </div>
  );
};

export default InterviewScheduleCreate;
